import React, { useState, useEffect, useContext } from "react";
import { useToasts } from 'react-toast-notifications';
import { getDropdown, generatePdfHeader } from "../../../constants/utils"
import * as XLSX from "xlsx"
import constant from "../../../constants/constant";
import organisms from "../../../components/organisms";
import service from "../../../api/services";
import { BASE_URL } from "../../../constants/defaultValues";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import { HeaderHeading } from "../../../Context";
import TopBar from "../../../components/molecules/TopBar";


const { AccountsDashboard } = organisms

const Index = () => {
    const { setHeader }: any = useContext(HeaderHeading);
    const [glAccountList, setGlAccountList] = useState();
    const [reportData, setReportData] = useState<any>({
        gl_account_number: "",
        created_from: Date,
        created_to: Date,
        report_format: NaN,
    })
    const { addToast } = useToasts();

    const getGlAccountList = async () => {
        try {
            const response = await service.DashboardService.accountList();
            if (response.status === 200) {
                setGlAccountList(getDropdown(response?.data?.data, "gl_number"))
            }
        } catch (error: any) {
            console.error(error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const handleSubmit = async () => {

        const payload = {
            account_id: reportData?.gl_account_number?.value,
            created_from: reportData?.created_from,
            created_to: reportData?.created_to
        };

        try {
            const response = await service.DashboardService.glAccountReport(payload)
            if (response.status === 200) {
                let path = response.data.data
                let fullPath = `${BASE_URL}${path}`
                let cleanPAth = fullPath.replace(/api\/\.\//, '')
                let fileName = cleanPAth.substring(cleanPAth.lastIndexOf("/") + 1)

                if (reportData?.report_format === constant?.DailyReportFormat[0].value) {

                    // convert the data to json
                    const xlsResponse = await fetch(cleanPAth);
                    const xlsData = await xlsResponse.arrayBuffer();

                    // Convert XLS data to JSON
                    const workbook = XLSX.read(new Uint8Array(xlsData), { type: 'array' });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(sheet);
                    generatePdfHeader(jsonData, 4, "general-account-report", "")
                }

                if (reportData?.report_format === constant?.DailyReportFormat[1].value) {

                    setTimeout(() => {
                        fetch(`${cleanPAth}`).then((response) => {
                            response.blob().then((blob) => {

                                // Creating new object of PDF file
                                const fileURL = window.URL.createObjectURL(blob);

                                // Setting various property values
                                let alink = document.createElement("a");
                                alink.href = fileURL;
                                alink.download = `${fileName}`;
                                alink.click();
                            });
                        });
                    }, 2000);
                }

            }
        } catch (error: any) {
            console.error('error', error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const handleChange = (name: string, value: any) => {
        setReportData({ ...reportData, [name]: value })
    }

    useEffect(() => {
        setHeader("Accounts - GL Report")
        getGlAccountList()
    }, [])
    return (
        <Wrapper>
            <TopBar />
            <AccountsDashboard
                handleChange={(name: string, value: any) => handleChange(name, value)}
                handleSubmit={() => handleSubmit()}
                glAccountList={glAccountList}
                reportData={reportData} />
        </Wrapper>
    )
}

export default Index